<template>
  <div class="credenciamento">
    <div v-if="mostrarConfirmacaoEmpresa" class="confirmacao-wrapper">
      <div class="confirmacao-card shadow-sm">
        <div class="confirmacao-logo-area">
          <img
            v-if="logoEmpresa && !erroLogo"
            :src="logoEmpresa"
            :alt="nomeEmpresa"
            class="confirmacao-logo"
            @error="erroLogo = true"
          />
          <div v-else class="confirmacao-logo-placeholder">
            <i class="fa fa-building"></i>
          </div>
        </div>

        <div class="confirmacao-conteudo">
          <div class="confirmacao-titulo">
            Confirmação da empresa
          </div>

          <div class="confirmacao-texto">
            Você está preenchendo os dados para a empresa
            <strong>{{ nomeEmpresa }}</strong>.
          </div>

          <div class="confirmacao-acoes">
            <b-button
              variant="primary"
              class="btn-confirmacao"
              @click="confirmarEmpresa"
            >
              Sim, está correto
            </b-button>

            <b-button
              variant="outline-secondary"
              class="btn-confirmacao"
              @click="voltarAlterarEmpresa"
            >
              Não, quero alterar
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <formulario
      v-if="formulario && exibirFormulario"
      :form="formulario"
      @executou="(r) => { if (r.status === 'success') this.enviarDados() }"
      @alterouCnpj="(r) => { this.alterouCnpj(r) }"
      :showEnviando="show"
    />
  </div>
</template>

<script>
import getUF from '@/composables/getUF'
import appUtils from '@/composables/utils'
import Card from 'src/components/Cards/Card.vue'
import { VMoney } from 'v-money'
import AgendaService from '../../../service/AgendaService'
import Formulario from '../../comuns/Formulario.vue'

export default {
  components: {
    Card,
    Formulario
  },
  data() {
    return {
      show: false,
      showFrom: "",
      filaShow: [],
      URL_PAGE: this.$route.query.page,
      formulario: null,
      optionsUF: getUF(),
      mascara: '(##)#####-####',
      empresa: '',
      tipo: 'PF',
      idEmpresa: 0,
      nomeEmpresa: '',
      logoEmpresa: null,
      erroLogo: false,
      idEmpresaPJ: null,
      destino: "Agenda",
      id: null,
      exibirFormulario: false,
      mostrarConfirmacaoEmpresa: false,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      dismissSecs: 5,
      dismissCountDown: 0,
      headerFalha: '',
      mensagemFalha: ''
    }
  },
  directives: { money: VMoney },

  async mounted() {
    try {
      this.empresa = this.$route.params.empresa
      const tipo = this.$route.query.tp
      const empresaPJ = this.$route.params.empresaPJ
      const destino = this.$route.query.dest
      const id = this.$route.query.ch

      if (tipo) this.tipo = atob(tipo)
      if (destino) this.destino = atob(destino)
      if (empresaPJ) this.idEmpresaPJ = empresaPJ
      if (id) this.id = atob(id)

      const { toast, ativarShow, desativarShow } = appUtils(this)

      if (!this.empresa) return

      this.optionsUF = getUF()

      let dadosConsulta = '{ "identificador": "' + this.empresa + '"}'

      ativarShow("buscarEmpresa")

      await AgendaService.buscarEmpresaPeloIdentificador(dadosConsulta)
        .then((resposta) => {
          let retorno = resposta.data

          if (retorno.status === "SUCCESS" && retorno.obj) {
            this.idEmpresa = retorno.obj.id
            this.nomeEmpresa = retorno.obj.nome || ''
            this.logoEmpresa = retorno.obj.logo || null
            this.erroLogo = false

            this.$store.dispatch('auth/loadEmpresa', retorno.obj)
          } else if (retorno.mensagens && retorno.mensagens.length > 0) {
            toast(retorno.mensagens[0].descricao, 'Falha', 'danger')
          }

          desativarShow("buscarEmpresa")
        })
        .catch((error) => {
          desativarShow("buscarEmpresa")
          toast(error, 'Falha', 'danger')
        })

      if (this.idEmpresa > 0) {
        if (this.loggedIn()) {
          this.mostrarConfirmacaoEmpresa = true
          this.exibirFormulario = false
        } else {
          this.$router.push({
            name: 'CriarConta',
            params: { empresa: this.empresa },
            query: { redirect: '/' + this.empresa + '/credenciamento' }
          })
        }
      }

    } catch (e) {
      alert(e)
    }
  },

  methods: {
    async confirmarEmpresa() {
      this.mostrarConfirmacaoEmpresa = false
      await this.carregarFormularioCredenciamento()
    },

    voltarAlterarEmpresa() {
      this.$router.push({ name: 'Credenciamentoi' })
    },

    async carregarFormularioCredenciamento() {
      const { toast, ativarShow, desativarShow } = appUtils(this)

      if (this.idEmpresa <= 0) return

      ativarShow("buscarFormularioCredenciamento")

      let dadosUsuario = JSON.parse(localStorage.getItem("dadosUsuario"))

      let dadosConsulta = {
        idProfissional: dadosUsuario.idPessoa,
        idEmpresa: this.idEmpresa,
        idEmpresaPJ: this.idEmpresaPJ,
        tipo: this.tipo,
        id: this.id
      }

      await AgendaService.buscarFormularioCredenciamento(dadosConsulta)
        .then((resposta) => {
          let retorno = resposta.data

          if (retorno.status === "SUCCESS") {
            this.formulario = retorno.obj

            this.formulario.campos
              .filter((c) => c.tipo == 'CNPJ')
              .forEach(c => {
                this.alterouCnpj({
                  campo: c.nome,
                  cnpj: c.valor
                })
              })

            this.exibirFormulario = true
          } else if (retorno.mensagens && retorno.mensagens.length > 0) {
            toast(retorno.mensagens[0].descricao, 'Falha', 'danger')
          }

          desativarShow("buscarFormularioCredenciamento")
        })
        .catch((error) => {
          desativarShow("buscarFormularioCredenciamento")
          toast(error, 'Falha', 'danger')
        })
    },

    async alterouCnpj(r) {
      var campoCnpj = this.formulario.campos.find(c => c.nome === r.campo)

      if (campoCnpj && campoCnpj.conf != null && campoCnpj.conf.validarCredenciamento) {
        var cred = null
        var cnpj = r.cnpj ? r.cnpj.replace(/[^0-9]/ig, '') : ''
        let tamanhoString = cnpj.length

        if (tamanhoString == 14) {
          cred = await this.buscarCredenciamento(cnpj)
        }

        var comCredenciamento = cred != null && cred.situacao == 'CCD'

        if (campoCnpj.conf.camposRemoverCredenciamento != null) {
          campoCnpj.conf.camposRemoverCredenciamento.forEach((cr) => {
            var campo = this.formulario.campos.find(c => c.nome === cr)
            if (campo) {
              campo.visivel = !comCredenciamento
            }
          })
        }

        if (campoCnpj.conf.camposAdicionarCredenciamento != null) {
          campoCnpj.conf.camposAdicionarCredenciamento.forEach((cr) => {
            var campo = this.formulario.campos.find(c => c.nome === cr)
            if (campo) {
              campo.visivel = comCredenciamento
            }
          })
        }
      }
    },

    async buscarCredenciamento(cnpj) {
      const { ativarShow, desativarShow } = appUtils(this)

      ativarShow("buscarCredenciamento")

      let dadosConsulta = {
        idEmpresa: this.idEmpresa,
        idsEliminar: [this.id],
        cnpj: cnpj
      }

      return await AgendaService.listaCredenciamento(dadosConsulta)
        .then((resposta) => {
          desativarShow("buscarCredenciamento")
          var resp = resposta.data
          return resp.status == 'SUCCESS' && resp.obj.length > 0 ? resp.obj[0] : null
        })
        .catch(() => {
          desativarShow("buscarCredenciamento")
          return null
        })
    },

    enviarDados() {
      const { toast } = appUtils(this)

      let dadosUsuario = JSON.parse(localStorage.getItem("dadosUsuario"))

      this.show = true

      let credenciamento = {
        idProfissional: dadosUsuario.idPessoa,
        idEmpresa: this.idEmpresa,
        formulario: this.formulario,
        tipo: this.tipo
      }

      AgendaService.enviarDadosCredenciamento(credenciamento)
        .then((resposta) => {
          let retorno = resposta.data

          if (retorno.status === "SUCCESS") {
            if (retorno.obj.erroValidacao == 'S') {
              let time = 1
              retorno.obj.mensagens.forEach((msg) => {
                setTimeout(function () {
                  toast(msg.descricao, msg.titulo, msg.tipo)
                }, time)
                time = time + 2000
              })

              this.formulario = retorno.obj.formulario
            } else {
              this.$router.push({
                name: 'PosEnviarCredenciamento',
                params: { empresa: this.empresa }
              })
            }
          } else {
            if (retorno.mensagens.length > 0) {
              let time = 1
              retorno.mensagens.forEach((msg) => {
                setTimeout(function () {
                  toast(msg.descricao, msg.titulo, msg.tipo)
                }, time)
                time = time + 3000
              })
            }
          }

          this.show = false
        })
        .catch((error) => {
          this.show = false
          toast(error, 'Falha', 'danger')
        })
    },

    loggedIn() {
      return this.$store.state.auth.status.loggedIn
    }
  }
}
</script>

<style scoped>
.credenciamento {
  min-height: 100%;
  padding: 24px 16px;
}

.confirmacao-wrapper {
  max-width: 760px;
  margin: 40px auto 0;
}

.confirmacao-card {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 18px;
  overflow: hidden;
}

.confirmacao-logo-area {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px 24px 16px;
  background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
}

.confirmacao-logo {
  max-width: 220px;
  max-height: 110px;
  object-fit: contain;
}

.confirmacao-logo-placeholder {
  width: 96px;
  height: 96px;
  border-radius: 18px;
  background: #eef2f7;
  color: #7a8797;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 34px;
}

.confirmacao-conteudo {
  padding: 8px 32px 32px;
  text-align: center;
}

.confirmacao-titulo {
  font-size: 24px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 16px;
}

.confirmacao-texto {
  font-size: 17px;
  line-height: 1.6;
  color: #4b5563;
  margin-bottom: 28px;
}

.confirmacao-acoes {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.btn-confirmacao {
  min-width: 190px;
  border-radius: 10px;
  padding: 10px 18px;
  font-weight: 600;
}

@media (max-width: 768px) {
  .credenciamento {
    padding: 16px 12px;
  }

  .confirmacao-wrapper {
    margin-top: 20px;
  }

  .confirmacao-logo {
    max-width: 180px;
    max-height: 90px;
  }

  .confirmacao-conteudo {
    padding: 8px 18px 24px;
  }

  .confirmacao-titulo {
    font-size: 21px;
  }

  .confirmacao-texto {
    font-size: 15px;
  }

  .btn-confirmacao {
    width: 100%;
  }
}
</style>